module.exports = __webpack_public_path__ + "static/media/luopan_pc_game.e3ad10c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameVideo/luopan_pc_game.mp4
// module id = WX8O
// module chunks = 0